/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { PictureOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { message, Spin, Upload } from 'antd-v5';

const beforeUpload = file => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    message.error('Image must be smaller than 5MB!');
  }
  return isJpgOrPng && isLt5M;
};

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const UploadKioskImage = ({ defaultImage, form, name, aspect = 1, resetKey }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  // Reset imageUrl when resetKey changes
  React.useEffect(() => {
    setImageUrl('');
  }, [resetKey]);

  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, url => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  async function handleUpload({ file, onSuccess }) {
    try {
      getBase64(file, url => {
        setLoading(false);
        setImageUrl(url);
        if (onSuccess) {
          onSuccess(url, file);
          form.setFieldValue(name, file);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <ImgCrop
      rotationSlider
      aspect={aspect}
      onModalCancel={resolve => {
        resolve(false); // Prevents upload and closes modal
      }}
    >
      <Upload.Dragger
        multiple={false}
        showUploadList={false}
        listType="picture-card"
        accept="image/*"
        action={e => console.log(e)}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={handleUpload}
      >
        <Spin spinning={loading}>
          {imageUrl || defaultImage ? (
            <img src={imageUrl || defaultImage} alt="Logo" style={{ maxWidth: '200px' }} />
          ) : (
            <>
              <PictureOutlined className="fs-18" />
              <p className="fs-12 gray margin-0">Click or drag file to this area to upload</p>
              <p className="fs-12 gray margin-0">Max size 1.5MB</p>
            </>
          )}
        </Spin>
      </Upload.Dragger>
    </ImgCrop>
  );
};
